export const dsmcReceiptHtml = `
<!DOCTYPE html>
<html lang="en">
  <head>
 
    <title>진료비 영수증</title>
  </head>
  <body>
    <div class="receipt-wrap dsmc">
      <div class="table1">
        <table>
          <tr>
            <td>
              <div class="main-title-wrap">
                <ul>
                  <li>[<span name="receipt_nm"></span>]진료비</li>
                  <li><span class="squre-box" name="receipt_type"></span>계산서</li>
                  <li><span class="squre-box" name="receipt_type"></span>영수증</li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table class="patient-info" style="table-layout: fixed;">
                <colgroup>
                  <col style="width:135px;">
                  <col style="">
                  <col style="">
  
  
                </colgroup>
                <tr>
                  <td style="width: 135px">환자등록번호</td>
                  <td style="width: 300px">환자성명</td>
                  <td  colspan="2" rowspan="2">
                    <table class="border-none">
                      <tr>
                        <td>진료기간</td>
                        <td style="width:155px;">야간(공휴일)진료</td>
                      </tr>
                      <tr>
                        <td>
                          <div class="period-wrap">
                            <span class="data-box" name="med_str_dt"></span>
                              부터
                            <span class="data-box" name="med_end_dt"></span>
                            까지
                          </div>
                        </td>
                        <td style="width:150px;">
                          <div class="checkbox-wrap">
                            <div>
                              <span class="squre-box-small" name="night_yn"></span>
                              <span>야간</span>
                            </div>
                            <div>
                              <span class="squre-box-small" name="holiday_yn"></span>
                              <span>공휴일</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td><span class="pt_no" name="pt_no"></span></td>
                  <td><span class="pt_nm" name="pt_nm"></span></td>
                </tr>

                <tr>
                  <td style="width: 135px">진료과목</td>
                  <td style="width: 200px">질병군(DRG)번호</td>
                  <td  colspan="2" rowspan="2">
                    <table class="border-none">
                      <tr>
                          <td style="width:130px;">병실</td>
                          <td >환자구분</td>
                          <td style="width:155px;">영수증번호(연월-일련번호)</td>
                      </tr>
                      <tr>
                          <td><span name="ward_room"></span></td>
                          <td><span name="pt_gb"></span></td>
                          <td>
                            <span name="receipt_id"></span>
                          </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td><span name="dept_nm"></span></td>
                  <td><span name="disease_cd"></span></td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <div class="row-div">
                <div>

                  <table style="table-layout:fixed">
                    <colgroup>
                      <col style="width:20px;">
                      <col style="width:55px;">
                      <col style="width:60px;">
                      <col style="">
                      <col style="">
                      <col style="">
                      <col style="">
                    </colgroup>
                    <tr>
                      <td colspan="3" rowspan="3" style="">항목</td>
                      <td colspan="3" >급여</td>
                      <td rowspan="3" style="width:132px;">비급여</td>
                    </tr>
                    <tr>
                      <td colspan="2">일부 본인부담</td>
                      <td rowspan="2" style="width:132px;text-align: center; line-height: 1.2">전액<br>본인부담</td>
                    </tr>
                    <tr>
                      <td style="width:132px;">본인부담금</td>
                      <td style="width:132px;">공담부담금</td>
                    </tr>
                    <tbody name="receipt_items">
                      <tr>
                        <td rowspan="18" style="width:20px;" class="txt-bold">
                          기<br/>본<br/>항<br/>목
                        </td>
                        <td colspan="2" style="">진찰료</td>

                        <td  style="">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td  style="">
                          <span name="insurance_price"></span>
                        </td>
                        <td  style="">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td style="">
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="3" style="">입원료</td>
                        <td style="">1인실</td>

                        <td style="">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td style="">
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="small-gap">2ㆍ3인실</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="small-gap">4인실이상</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">식대</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2">투약 및<br/>조제료</td>
                        <td>행위료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td>약품비</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2">주사료</td>
                        <td>행위료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td>약품비</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">마취료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">처치 및 수술료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">검사료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">영상진단료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">방사선치료료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">치료재료대</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">재활 및 물리치료료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">정신요법로</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="small-gap">전혈 및 혈액성분제제료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="6" class="txt-bold">선<br/>택<br/>항<br/>목</td>
                        <td colspan="2">CT 진단료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">MRI 진단료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">PET 진단료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">초음파 진단료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">보철ㆍ교정료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">제증명수수료</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">선별급여</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">65세 이상 등 정액</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">정액수가(완화의료)</td>
                       <td width="143px">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">질병군 포괄수가</td>

                        <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">기타</td>


                         <td>
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td>
                          <span name="insurance_price"></span>
                        </td>
                        <td>
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td>
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">합계</td>
                        <td class="bg-red">
                          <div class="prefix-wrap">
                            <span>①</span>
                            <span
                              name="partial_patient_responsibility_price"
                            ></span>
                          </div>
                        </td>
                        <td>
                          <div class="prefix-wrap">
                            <span>②</span>
                            <span name="insurance_price"></span>
                          </div>
                        </td>
                        <td class="bg-red">
                          <div class="prefix-wrap">
                            <span>③</span>
                            <span
                              name="full_patient_responsibility_price"
                            ></span>
                          </div>
                        </td>
                        <td class="bg-red">
                          <div class="prefix-wrap">
                            <span>④</span>
                            <span name="uninsurance_price"></span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">상한액 초과금</td>
                        <td class="bg-red">
                          <div class="prefix-wrap">
                            <span>⑤</span>
                            <span name="over_limit_price"></span>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table>
                    <tr>
                      <td colspan="3" class="tit-bg">금액산정내용</td>
                    </tr>
                    <tr>
                      <td colspan="2"class="row-2">
                        ⑥진료비 총액<br />
                        (①+②+③+④)
                      </td>
                      <td style="width: 150px">
                        <span name="total_price"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="row-2">
                        ⑦공단부담 총액<br />
                        (②+⑤)
                      </td>
                      <td>
                        <span name="total_insurance_price"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="row-2" >
                        ⑧환자부담 총액<br />
                        (①-⑤)+③+④)
                      </td>
                      <td>
                        <span
                          name="total_partial_patient_responsibility_price"
                        ></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" >⑨이미 납부한 금액</td>
                      <td>
                        <span name="already_paid_price"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2"  class="row-2">
                        ⑩납부할 금액<br />
                        (⑧-⑨)
                      </td>
                      <td>
                        <span name="price_to_be_paid"></span>
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="4">⑪납부<br />한 금액</td>
                      <td>카드</td>
                      <td>
                        <span name="price_paid_card"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>현금영수증</td>
                      <td>
                        <span name="price_paid_cash_receipt"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>현금</td>
                      <td>
                        <span name="price_paid_cash"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>합계</td>
                      <td class="bg-red">
                        <span name="price_paid_total"></span>
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="4">납부 하지<br />않은 금액<br />(⑩-⑪)</td>
                      <td>감면</td>
                      <td>
                        <span name="price_not_paid_discounted"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>후불</td>
                      <td>
                        <span name="price_not_paid_postpaid"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td></td>
                    </tr>
                  </table>

                  <table>
                    <tr>
                      <td colspan="2" class="tit-bg">신용카드내역</td>
                    </tr>
                    <tr>
                      <td style="width: 100px">가맹점번호</td>
                      <td>
                        <span name="business_registration_number"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>카드번호</td>
                      <td>
                        <span name="card_number"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>카드종류</td>
                      <td class="card-align-left">
                        <span name="card_company" class="card-align-left"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>할부개월</td>
                      <td>
                        <span name="installment_month"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>승인번호</td>
                      <td>
                        <span name="approval_number"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        현금영수증(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                      </td>
                    </tr>
                    <tr>
                      <td>신분확인번호</td>
                      <td>
                        <span name="cash_receipt_id_number"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>현금승인번호</td>
                      <td>
                        <span name="cash_receipt_approval_number"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>발행일시</td>
                      <td class="card-align-left">
                        <span name="issue_datetime"></span>
                      </td>
                    </tr>
                    <tr>
                      <td>수납자</td>
                      <td class="card-align-left">
                        <span name="payee_name"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" style="height: 100%">
                        <div style="height: 100%">&nbsp;</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <table class="footer-info">
                  <tr>
                    <td style="width: 135px">요양기관 종류</td>
                    <td colspan="5">
                      <div class="row-between">
                        <div class="checkbox-wrap align-left">
                          <span class="squre-box-small check"></span>
                          <span>상급종합병원</span>
                        </div>
                        <div class="pl-box">
                          <span name="cutoff_price"></span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 100px">사업자등록번호</td>
                    <td class="txt-bold"><span>501-82-03466</span></td>
                    <td style="width: 100px">상호</td>
                    <td  class="txt-bold"><span>계명대학교 동산의료원</span></td>
                    <td style="width: 100px">대표자</td>
                    <td class="dsmc-official-seal">
                      <div class="prefix-wrap">
                        <span name="rpst_nm"></span>
                        <span>인</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>사업장 소재지</td>
                    <td colspan="3">
                      <span>대구광역시 달서구 달구벌대로 1035(신당동)</span>
                    </td>
                    <td>대표전화</td>
                    <td class="txt-bold">
                      <span>1577-6622</span>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table2">
        <table>
          <tr>
            <td class="tit-bg">
              [<span name="additional_content_title"></span>]
            </td>
            <td class="tit-bg">투약번호</td>
          </tr>
          <tr>
            <td rowspan="3" style="width: 200px; vertical-align:top; height:100%;" class="barcode-td">
            <div class="barcode-wrap" style="height:500px;">
              <div name="barcode" class="barcode" >
              <svg className='parking-barcode' id='receipt-barcode-0' alt='barcode' preserveAspectRatio='none'></svg>
              </div>
              <span name="additional_content_value"></span>
              </div>
            </td>
            <td style="height:272px" class="align-left">
              <span name="phr_info"></span>
            </td>
          </tr>
          <tr>
            <td class="tit-red">
              주차 할인 안내<br />(진료비 영수증으로 확인)
            </td>
          </tr>
          <tr>
            <td>
              <div style="text-align: left; padding: 20px 5px;" class="txt-bold">
                ★외래진료<br />
                - 4시간 무료<br />
                - 2개과 외래진료 시 8시간 무료
                <br />
                <br />
                ★입원<br />
                - 입ㆍ퇴원 당일 6시간<br />
                - 수술 당일 12시간<br />
                - 고위험 수술 당일 8시간 무료<br />
                <span class="txt-red">(이외 입원기간 주차요금 부과)</span>
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="2" class="tit-bg">항목별 설명</td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="info-wrap1">
                <div class="section">
                  <div class="num">1.</div>
                  <div class="con">
                    <div class="content">
                      일부 본인부담: 일반적으로 다음과 같이 본인부담률을
                      적용하나, 요양기관 지역, 요양기관의 종별, 환자 자격,
                      선별급여(「국민건강보험법」 제41조의4에 따른 요양급여)
                      여부, 병실종류 등에 따라 달라질 수 있습니다.<br />
                      <ul class="list">
                        <li>
                          <span>- 외래 본인부담률 :</span>
                          <p>
                            요양기관 종별에 따라 30% ~ 60%(의료급여 수급권자 종별
                            및 의료급여기관 유형 등에 따라 0원 ~ 2,500원, 0% ~ 15%) 등
                          </p>
                        </li>
                        <li>
                          <span>- 입원 본인부담률 :</span>
                          <p>
                            20%(의료급여 수급권자 종별 및 의료급여기관 유형 등에
                            따라 0% ~ 10%) 등
                          </p>
                        </li>
                      </ul>

                      ※ 식대: 50%(의료급여는 20%) /
                      CTㆍMRIㆍPET: 외래 본인부담률(의료급여는 입원
                      본인부담률과 동일) /
                      선별급여(「국민건강보험법」 제41조의4에 따른 요양급여): 보건복지부장관이 고시한 항목별 본인부담률(50%,
                      80%, 90%)<br />
                      ※ 상급종합병원 입원료: 2인실 50%, 3인실 40%, 4인실 30% /
                      병원급 의료기관(치과병원 제외) 입원료: 2인실 40%, 3인실
                      30%
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div class="num">2.</div>
                  <div class="con">
                    <div class="content">
                      전액 본인부담:「국민건강보험법 시행규칙」 별표 6 또는
                      「의료급여법 시행규칙」 별표 1의2에 따라 적용되는
                      항목으로, 건강보험(의료급여)에서 금액을 정하고 있으나
                      진료비 전액을 환자 본인이 부담합니다.
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div class="num">3.</div>
                  <div class="con">
                    <div class="content">
                      상한액 초과금:「국민건강보험법 시행령」 별표 3 제1호에
                      따른 본인부담상한액의 최고 금액을 초과하는 본인부담금이
                      발생한 경우[단,「의료법」 제3조제2항제3호라목에 따른
                      요양병원(「장애인복지법」 제58조제1항제4호에 따른
                      장애인 의료재활시설로서 「의료법」 제3조의2의 요건을 갖춘
                      의료기관인 요양병원은 제외)에 입원한 기간이 같은 연도에 120일을
                      초과하는 경우는 제외],공단이 부담하는 초과분 중 사전 정산하는 금액을 말합니다.<br />
                      ※ 전액 본인부담 및 선별급여(「국민건강보험법」제 41조 4에 따른 요양급여)의 본인부담금 등은 본인부담상한액 산정시 제외합니다.
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div class="num">4.</div>
                  <div class="con">
                    <div class="content">
                      "질병군 포괄수가"란 「국민건강보험법 시행령」
                      제21조제3항제2호 및 「국민건강보험 요양급여의 기준에 관한
                      규칙」 제8조제3항에 따라, 보건복지부장관이 고시한 질병군
                      입원진료에 대하여 해당 입원진료와 관련되는 여러 의료행위를 하나의 행위로 정하여
                      요양급여비용을 결정한 것을 말합니다.
                      다만, 해당 질병군의 입원진료와 관련되는 의료행위라도 비급여대상이나 이송처치료 등 포괄수가에서
                      제외되는 항목은 위 표의 기본항목 및 선택항목란에 합산하여
                      표기됩니다.
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="tit-bg">일반사항 설명</td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="info-wrap2">
                <div class="section">
                  <div class="num">1.</div>
                  <div class="con">
                    <div class="content">
                      이 계산서ㆍ영수증에 대한 세부내용은 요양기관에 요구하여
                      제공받을 수 있습니다.
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div class="num">2.</div>
                  <div class="con">
                    <div class="content">
                      「국민건강보험법」 제48조 또는 「의료급여법」에 제11조의3에 따라 환자가
                      전액 부담한 비용과 비급여로 부담한 비용의 타당성 여부를
                      건강보험심사평가원(📞1644-2000, 홈페이지:
                      <a href="http://www.hira.or.kr" target="_blank"
                        >www.hira.or.kr)</a
                      >에 확인 요청하실 수 있습니다.
                    </div>
                  </div>
                </div>

                <div class="section">
                  <div class="num">3.</div>
                  <div class="con">
                    <div class="content">
                      계산서ㆍ영수증은 「소득세법」에 따른 의료비 공제신청 또는 「조세특례제한법」에
                      따른 현금영수증 공제신청(현금영수증 승인번호가 적힌 경우만 해당합니다)에 사용할 수 있습니다.
                      다만, 지출증빙용으로 발급된 "현금영수증(지출증빙)"은 공제신청에 사용할 수 없습니다.<br />

                      (현금영수증 문의 126 인터넷 홈페이지 : http://현금영수증.kr)
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <td colspan="2">
            <div class="info-wrap3">
              <div class="section">
                <span class="tit">주(註)</span>
                <span class="con">
                  <div class="content">
                    <ul class="list">
                      <li>
                        <div class="num">1.</div>
                        <div class="con">
                          진료항목 중 선택항목은 요양기관의 특성에 따라 추가
                          또는 생략할 수 있으며, 야간(공휴일) 진료 시 진료비가
                          가산될 수 있습니다.
                        </div>
                      </li>
                      <li>
                        <div class="num">2.</div>
                        <div class="con">
                          환자가 「위기 임신 및 보호출산 지원과 아동 보호에 관한
                          특별법」 제2조제3호에 따른 비식별화된 가명을 부여받은
                          경우에는 환자의 성명 대신 가명을 기재할 수 있습니다.
                        </div>
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
            </div>
          </td>
        </table>
      </div>
    </div>
  </body>
</html>
`;
